export const prodHeaders = [
  {name: 'No.', val: 0},
  {name: 'Product', val: -1},
  {name: 'Product Name', val: 1},
  {name: 'Unit Price', val: 2},
  {name: 'Stock', val: 3},
  {name: 'Qty Sold', val: 4},
  {name: 'Earnings', val: 5},
  {name: 'Stock Status', val: 6},
  {name: 'Actions', val: -1}
]

export const couponHeaders = [
  {name: 'No.', val: 0},
  {name: 'Coupon Name', val: 1},
  {name: 'Type', val: 2},
  {name: 'Amount', val: 3},
  {name: 'Status', val: 4},
  {name: 'Expiry Date', val: 5},
  {name: 'Actions', val: -1}
]

export const shipHeaders = [
  {name: 'No.', val: 0},
  {name: 'Shipping Method', val: 1},
  {name: 'Company', val: 2},
  {name: 'Price', val: 3},
  {name: 'Countries', val: 4},
  {name: 'Status', val: 5},
  {name: 'Actions', val: -1},
]

export const colorsOpts = [
  {name:'Choose a Color', value: ''},
  {name: 'Black', value: '#222'},
  {name: 'Red', value: '#ff174d'},
  {name: 'Green', value: '#47d400'},
  {name: 'Blue', value: '#00a2ff'},
  {name: 'Orange', value: '#ff9100'},
  {name: 'Yellow', value: '#ffea05'},
  {name: 'Pink', value: '#edb5ff'},
  {name: 'Gray', value: '#b5b5b5'}
]

export const sizeOpts = [
  {name:'Choose a Size', value: ''},
  {name: 'Extra Small', value: 'xs'},
  {name: 'Small', value: 's'},
  {name: 'Medium', value: 'm'},
  {name: 'Large', value: 'l'},
  {name: 'Extra Large', value: 'xl'},
]

export const courrierOpts = [
  {name: 'Fedex', value: 'fedex'},
  {name: 'Canada Post', value: 'canadapost'},
  {name: 'Uhaul', value: 'uhaul'},
  {name: 'UPS', value: 'ups'},
  {name: 'Purolator', value: 'purolator'},
  {name: 'DHL', value: 'dhl'},
]

export const initSalesMonthsObj = [
  {name: 'january', month: 1, value: 0},
  {name: 'february', month: 2, value: 0},
  {name: 'march', month: 3, value: 0},
  {name: 'april', month: 4, value: 0},
  {name: 'may', month: 5, value: 0},
  {name: 'june', month: 6, value: 0},
  {name: 'july', month: 7, value: 0},
  {name: 'august', month: 8, value: 0},
  {name: 'september', month: 9, value: 0},
  {name: 'october', month: 10, value: 0},
  {name: 'november', month: 11, value: 0},
  {name: 'december', month: 12, value: 0}
]

